module.exports = __webpack_public_path__ + "static/media/mav-uzemi-epulet.f472d4aa.jpg";